namespace('compass.arctic');

compass.arctic.HeaderWidget = compass.defineWidget(function HeaderWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;
	var _headerDescription;

	this.setupControls = function() {

	};

	this.setMeetingData = function(data) {

	};

	this.render = function(widgetElem) {
		var d = _d;
		_headerDescription = d.h2({ tabindex : -1 });

		var widgetContents = [
			me.drawEventLogo(),
			d.h1(me.drawEventDetails()),
			d.reader(_headerDescription),
			d.separator()
		];

		widgetElem.append(
			widgetContents
		).attr({'aria-role':'banner', 'role': 'banner'});

		me.setupControls();
	};

	function goHome() {
		return;
		//window.location =  compass.rootPrefix + '/' + compass.matchDict.meetingCode;
	}

	this.setHeaderDescription = function(headerDescription){
		// prepend a string that a screen reader can read to the header (for better readibility of each page)
		_headerDescription.text(headerDescription).focus();
	};

	this.drawEventDetails = function() {
		var d = _d;
		var mi = _settings.meetingInfo;
		var addr = d.div({ className : 'eventAddr' },
			d.span({ className : 'eventCity' }, mi.site.city)
		);

		if(mi.site.state) {
			addr.append(d.span({ className : 'eventState' }, ',&nbsp;', mi.site.state));
		}
		if(mi.site.country.toLowerCase() != 'united states') {
			addr.append(
				d.span({ className : 'eventCountry' }, 
					',&nbsp;', mi.site.country.toLowerCase()
				)
			);
		}

		var eventDetails = d.div({ className : 'eventDetails' },
			d.div({ className : 'eventDates' }, mi.datesDisplay),
			d.div({ className : 'eventLocation notranslate' }, mi.site.name),
			addr
		);

		if(mi.hideMeetingSubheader) {
			eventDetails.empty();
		}

		return d.div({ className : 'eventHeader'},
			d.div({ className : 'eventName notranslate' }, mi.name),
			eventDetails
		).activate(goHome);
	};

	this.drawEventLogo = function() {
		var d = _d;
		var logo = d.div({ className : 'eventLogo'});
		logo.html(_settings.meetingInfo.headerContent);
		return logo;
	};

	var _d = jQuery.dom.getContext(this);
},
{ WUID : 'defaultHeaderWidgetWUID',
	widgetName : 'HeaderWidget',
	meetingInfo : {headerContent : "", "starts": "04/29/2012", "ends": "05/01/2012", "datesDisplay" : "Oct 12-15, 1337", "name": "Generic Test 111029125332", "site": {"latitude": 41.8554, "name": "McCormick Place Convention Center", "longitude": -87.6152, city : "Orlando", state : "FL"}
	}
}
);

